export const config = {
  data() {
    return {
      columns: []
    };
  },
  methods: {
    getColumns() {
      let columns = [
        {
          title: `${this.type == 1 ? '保险公司' : '合作通道'}`,
          align: 'center',
          minWidth: 140,
          render(h, params) {
            let insuranceName = params.row.insuranceName;
            if (insuranceName) {
              return h('span', [insuranceName]);
            } else {
              return h('span', ['-']);
            }
          }
        },
        {
          title: '工号',
          minWidth: 120,
          align: 'center',
          key: 'staffNo'
        },
        {
          title: '上号状态1',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let bjsSyncStatus = params.row.bjsSyncStatus;
            if (bjsSyncStatus == '1') {
              return <span class="my-tag green">已上号</span>;
            } else {
              return <span class="my-tag org">未上号</span>;
            }
          }
        },
        {
          title: '扩展字段',
          minWidth: 100,
          key: 'extParam',
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 160,
          fixed: 'right'
        }
      ];
      this.columns = columns;
    }
  }
};
